import { render, staticRenderFns } from "./_termCard.vue?vue&type=template&id=3d188a54&scoped=true"
import script from "./_termCard.vue?vue&type=script&lang=js"
export * from "./_termCard.vue?vue&type=script&lang=js"
import style0 from "./_termCard.vue?vue&type=style&index=0&id=3d188a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d188a54",
  null
  
)

export default component.exports